"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames2 = require("classnames");

var _classnames3 = _interopRequireDefault(_classnames2);

var _DataTableCell = require("./DataTableCell");

var _DataTableCell2 = _interopRequireDefault(_DataTableCell);

var _reactIcon = require("@cdk-uip/react-icon");

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
/**
 * Data table header cell.
 */


var DataTableHeaderCell = function DataTableHeaderCell(_ref) {
  var sortable = _ref.sortable,
      sortDirection = _ref.sortDirection,
      className = _ref.className,
      children = _ref.children,
      other = _objectWithoutProperties(_ref, ["sortable", "sortDirection", "className", "children"]);

  return _react2.default.createElement(_DataTableCell2.default, _extends({
    type: "th",
    className: (0, _classnames3.default)(_defineProperty({
      "cdk-data-table__column-sort": sortable && sortDirection !== "none"
    }, "cdk-data-table__column-sort--" + sortDirection, sortable && sortDirection !== "none"), className)
  }, other), sortable && _react2.default.createElement(_reactIcon.Icon, null, "arrow_upward"), children);
};

DataTableHeaderCell.propTypes = {
  /** Make the column sortable */
  sortable: _propTypes.bool,

  /** The sort direction */
  sortDirection: (0, _propTypes.oneOf)(["none", "asc", "desc"])
};
exports.default = DataTableHeaderCell;